// Sample images

// Patterns
import EMSATrainingPrograms from './components/EMSATrainingPrograms/EMSATrainingPrograms';

function App() {

  return (
    <>
      <div className={'main-content'} id={'main-content'}>
        <main id={'main'} className={'main-primary'}>
          {/* Banner removed as requested */}
          <div id="emsa-programs">
            <EMSATrainingPrograms />
          </div>
        </main>
      </div>
    </>
  );
}

export default App;
